import { ErrorBoundary } from "react-error-boundary";
import Modal from "@/shared/ui/modal/Modal";
import { BankBranch } from "@/domains/bank/components/BankBranch/BankBranch";

export function BankBranchModal({
  open,
  onClose,
  filialId,
}: {
  open: boolean;
  onClose: () => void;
  filialId: number | null;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="w-fit p-0 bg-dark-900 rounded-[1rem]"
      classNameCloseBtn="top-13 right-14"
      overlay={false}
      style={{
        boxShadow: "0px 0px 200px 0px rgba(34, 139, 34, 0.60)",
        fontFamily: "TT Norms Pro",
      }}
    >
      <ErrorBoundary
        fallback={<div className="p-4">Произошла ошибка при загрузке филиала банка</div>}
      >
        <BankBranch branchId={filialId} />
      </ErrorBoundary>
    </Modal>
  );
}
